import {
    GET_STUDENTS,
    GET_DEFINACION,
    GET_COURSES_BY_BADGE,
    UPDATE_STUDENTS,
    CIN_LOADING
} from "../actions/ExtracurricularCoursesIntructorAction";


const initialState = {
    studentsList: [],
    coursesList: [],
    definition: [],
    add:false,
    loading: false,
};

const UserAdmin = function (state = initialState, action) {
    switch (action.type) {
        case CIN_LOADING: {
            return {
                ...state,
                loading: true,
                add: false
            };
        }
        case GET_COURSES_BY_BADGE: {
            return {
                ...state,
                coursesList: [...action.data],
                loading: false,
            }
        }
        case GET_DEFINACION: {
            return {
                ...state,
                definition: [...action.data],
                loading: false
            }
        }
        case GET_STUDENTS: {
            return {
                ...state,
                studentsList: [...action.data],
                loading: false
            };
        }
        case UPDATE_STUDENTS: {
            return {
                add : true,
                loading: false  
              }; 
        }
        default: {
            return state;
        }
    }
}

export default UserAdmin;
